import axios from 'axios/dist/axios';


const defaultState = {
    assessmentList: [],
    isLoadingAssessmentListData: false,
    isLoadingAssessmentCount: false,
    assessmentListTotalLength: null,

    searchCriteria: { // The same properties as those received from API for each assessment in list.
        token: "",
        version:"",
        date: "",
        productName: "",
        pid: "",
        userFirstName: "",
        userLastName: "",
        userInstitution: "",
    },
    msitat: "",
    pagination: {
        sortBy: 'date',
        descending: true,
        rowsPerPage: 10,
        page: 1,
        totalItems: 0
    },
    lastClickedAssessmentId: null
};

// ======================================================================
// Initial State
// ======================================================================

const state = {
    assessmentList: defaultState.assessmentList,
    isAssessmentListDataLoading: defaultState.isLoadingAssessmentListData,
    isAssessmentCountLoading: defaultState.isLoadingAssessmentCount,
    assessmentListTotalLength: defaultState.assessmentListTotalLength,
    searchCriteria: defaultState.searchCriteria,
    msitat: defaultState.msitat,
    pagination: defaultState.pagination,
    lastClickedAssessmentId: defaultState.lastClickedAssessmentId
};


// ======================================================================
// Getters
// ======================================================================

const getters = {
    getAssessmentList: state => state.assessmentList,
    getIsAssessmentListDataLoading: state => state.isAssessmentListDataLoading,
    getIsAssessmentListTotalLoading: state => state.isAssessmentCountLoading,
    getAssessmentListTotalLength: state => state.assessmentListTotalLength,
    getSearchCriteria: state => state.searchCriteria,
    getMsitat: state => state.msitat,
    getPagination: state => state.pagination,
    getLastClickedAssessmentId: state => state.lastClickedAssessmentId,
};


// ======================================================================
// Actions
// ======================================================================
function prepareAssessmentListRequest(computeCountWithoutData, getters){
    let req =  {
        sortBy: getters.getPagination.sortBy,
        descending: getters.getPagination.descending,
        page: getters.getPagination.page,
        rowsPerPage: getters.getPagination.rowsPerPage,
        computeCountWithoutData: computeCountWithoutData,

        assessmentSearchCriteria: {
            assessmentToken: getters.getSearchCriteria.token,
            assessmentVersion: getters.getSearchCriteria.version,
            recDate: getters.getSearchCriteria.date,
            productName: getters.getSearchCriteria.productName,
            pid: getters.getSearchCriteria.pid,
            userFirstName: getters.getSearchCriteria.userFirstName,
            userSurname: getters.getSearchCriteria.userLastName,
            userInstitution: getters.getSearchCriteria.userInstitution,
        }
    };

    // If there is a MSITAT, pass it to the API too.
    if (getters.getMsitat !== defaultState.msitat) {
        req.msitat = getters.getMsitat;
    }
    return req;
}


const actions = {

    loadAssessmentListData ({commit, getters}) {

        return new Promise((resolve, reject) => {

            commit("setIsAssessmentListDataLoading", true);

            let requestParams = prepareAssessmentListRequest(false, getters);
            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessmentList', requestParams);
            axiosRequest.then((response) => {
                // SUCCESS
                commit("setAssessmentList", response.data.rows);
                resolve(response);
            });
            axiosRequest.catch((error) => {
                // FAILURE
                console.log(error);
                reject(error);
            });
            axiosRequest.then(() => {
                // ALWAYS
                commit("setIsAssessmentListDataLoading", false);
            });
        })
    },

    loadAssessmentCount ({commit, getters}) {

        return new Promise((resolve, reject) => {

            commit("setIsAssessmentCountLoading", true);

            let requestParams = prepareAssessmentListRequest(true, getters);
            let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessmentList', requestParams);
            axiosRequest.then((response) => {
                // SUCCESS
                commit("setAssessmentListTotalLength", response.data.totalLength);
                resolve(response);
            });

            axiosRequest.catch((error) => {
                // FAILURE
                console.log(error);
                reject(error);
            });
            axiosRequest.then(() => {
                // ALWAYS
                commit("setIsAssessmentCountLoading", false);
            });

        })
    }

};

// ======================================================================
// Mutations
// ======================================================================

const mutations = {

    setAssessmentList (state, data) {
       state.assessmentList = data;
    },
    setIsAssessmentListDataLoading (state, newValue) {
        state.isAssessmentListDataLoading = newValue;
    },
    setIsAssessmentCountLoading (state, newValue) {
        state.isAssessmentCountLoading = newValue;
    },
    setAssessmentListTotalLength (state, newValue) {
        state.assessmentListTotalLength = newValue;
    },

    setSearchCriteria (state, newData) {
        state.searchCriteria = newData;
    },
    setSearchCriterionByColumn (state, {columnKey, newValue}) {
        state.searchCriteria[columnKey] = newValue;
    },
    clearSearchCriteria (state) {
        state.searchCriteria = defaultState.searchCriteria;
    },

    setMsitat (state, newValue) {
        state.msitat = newValue;
    },

    setPagination (state, newData) {
        state.pagination = newData;
    },
    setPage (state, newValue) {
        state.pagination.page = newValue;
    },
    setRowsPerPage (state, newValue) {
        state.pagination.rowsPerPage = newValue;
    },

    setLastClickedAssessmentId (state, newValue) {
        state.lastClickedAssessmentId = newValue;
    },


    // ----------------------------------------------------------

    resetStore (state) {
        state.assessmentList = defaultState.assessmentList;
        state.isAssessmentCountLoading = defaultState.isLoadingAssessmentCount;
        state.isAssessmentListDataLoading = defaultState.isLoadingAssessmentListData;
        state.assessmentListTotalLength = defaultState.assessmentListTotalLength;
        state.msitat = defaultState.msitat;
        state.pagination = defaultState.pagination;
        state.lastClickedAssessmentId = defaultState.lastClickedAssessmentId;
    }
};


// ======================================================================
// Exports
// ======================================================================

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/common/store/modules/AssessmentListStore.js